import server from "../../../views/agent_im/server";
import { format } from "date-fns";
import ImMessage from "@/components/im/message/index";
import { utcToZonedTime } from "date-fns-tz";

export default {
    name: "im-message",
    props: {
        message: {
            type: Object,
            default: {}
        },
        useTranslate: {
            type: Boolean,
            default: false
        },
        useLocalTime: {
            type: Boolean,
            default: false
        },
        timezone: {
            // 'UTC +8'
            type: String,
            default: ""
        },
        isTranslate: {
            type: Boolean,
            default: false
        }
    },
    components: { ImMessage },
    data() {
        return {
            textContent: "",
            imgContent: "",
            children: [],
            translateStatus: "start", //'start' 尚未翻译 'ing 正在翻译  'success'翻译成功 'fail'翻译失败
            translateContent: ""
        };
    },
    computed: {
        create_time_format() {
            let localDate = new Date(this.message.create_time * 1000);
            if (this.useLocalTime && this.timezone) {
                //专用户时间
                localDate = utcToZonedTime(localDate, this.timezone);
            }
            return format(localDate, "yyyy-MM-dd HH:mm:ss");
        }
    },

    methods: {
        sendAgain() {
            this.message.sending = 1;
            server.sendAction(this.message);
        }
    }
};
